import { shape, string } from "prop-types";

const StyleVariableShape = shape({
  name: string,
  type: string
});

export default StyleVariableShape;
